@if (visible()) {
  <nav class="paginador" aria-label="Paginación">
    <button
      type="button"
      class="paginador__flecha"
      [disabled]="paginaActual() <= 1"
      (click)="anterior()"
      aria-label="Página anterior"
    >
      <svg app-icono nombre="caret-left"></svg>
    </button>

    <!-- track por índice: con muchas páginas hay dos elipsis y trackear por
         valor colisiona (NG0955). -->
    @for (item of paginas(); track $index) {
      @if (item === elipsis) {
        <span class="paginador__elipsis" aria-hidden="true">{{ elipsis }}</span>
      } @else if (item === paginaActual()) {
        <span class="paginador__num paginador__num--activa" aria-current="page">
          {{ item }}
        </span>
      } @else {
        <button
          type="button"
          class="paginador__num"
          (click)="irA(item)"
          [attr.aria-label]="'Ir a la página ' + item"
        >
          {{ item }}
        </button>
      }
    }

    <button
      type="button"
      class="paginador__flecha"
      [disabled]="paginaActual() >= totalPaginas()"
      (click)="siguiente()"
      aria-label="Página siguiente"
    >
      <svg app-icono nombre="caret-right"></svg>
    </button>
  </nav>
}
